import { BehaviourDataActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    momentaryDataList: null,
    saved_RecordMomentaryData: null,
    todaysMomentaryDataList: null,
    deletedTodaysMomentaryData: null,
    isStart: false,
    isSave: false,
    secondsElapsed: 0,
    observationSecondsElapsed: 0,
    intervalCount: 1,
    recordMomentaryCustomTime: null,
    incrementer: [],
    newIncrementer: [],
    observationIncrementerOne: [],
    observationIncrementerTwo: [],
    customMomentaryArray: []
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case BehaviourDataActionTypes.save_patientRecordMomentaryData.REQUEST:
            return {
                ...state,
                loading: true,
                saved_RecordMomentaryData: null,
            };
        case BehaviourDataActionTypes.save_patientRecordMomentaryData.SUCCESS:
            return {
                ...state,
                loading: false,
                saved_RecordMomentaryData: payload,
            };

        case BehaviourDataActionTypes.get_patientRecordMomentaryData_List.REQUEST:
            return {
                ...state,
                loading: true,
                momentaryDataList: null,
            };
        case BehaviourDataActionTypes.get_patientRecordMomentaryData_List.SUCCESS:
            return {
                ...state,
                loading: false,
                momentaryDataList: payload,
            };

        case BehaviourDataActionTypes.get_patientTodaysRecordMomentaryDataList.REQUEST:
            return {
                ...state,
                loading: true,
                todaysMomentaryDataList: null,
            };
        case BehaviourDataActionTypes.get_patientTodaysRecordMomentaryDataList.SUCCESS:
            return {
                ...state,
                loading: false,
                todaysMomentaryDataList: payload,
            };

        case BehaviourDataActionTypes.delete_patientTodaysRecordMomentaryDataList.REQUEST:
            return {
                ...state,
                loading: true,
                deletedTodaysMomentaryData: null,
            };
        case BehaviourDataActionTypes.delete_patientTodaysRecordMomentaryDataList.SUCCESS:
            return {
                ...state,
                loading: false,
                deletedTodaysMomentaryData: payload,
            };

        case BehaviourDataActionTypes.start_recordMomentaryTimer.SUCCESS:
            return {
                ...state,
                loading: false,
                isStart: payload.isStart,
                isSave: payload.isSave
            }

        case BehaviourDataActionTypes.start_secondsElapsedForMomentary.SUCCESS:
            return {
                ...state,
                loading: false,
                secondsElapsed: payload
            }

        case BehaviourDataActionTypes.reset_secondsElapsedForMomentary.SUCCESS:
            return {
                ...state,
                loading: false,
                secondsElapsed: payload
            }

        case BehaviourDataActionTypes.start_secondsElapsedForMomentaryObservation.SUCCESS:
            return {
                ...state,
                loading: false,
                observationSecondsElapsed: payload
            }

        case BehaviourDataActionTypes.reset_secondsElapsedForMomentaryObservation.SUCCESS:
            return {
                ...state,
                loading: false,
                observationSecondsElapsed: payload
            }

        case BehaviourDataActionTypes.set_MomentaryIntervalCount.SUCCESS:
            return {
                ...state,
                loading: false,
                intervalCount: payload,
            };
        case BehaviourDataActionTypes.reset_MomentaryIntervalCount.SUCCESS:
            return {
                ...state,
                loading: false,
                intervalCount: 1,
            };
        case BehaviourDataActionTypes.get_patientRecordMomentaryCustomTimeData.REQUEST:
            return {
                ...state,
                loading: true,
                recordMomentaryCustomTime: null
            }
        case BehaviourDataActionTypes.get_patientRecordMomentaryCustomTimeData.SUCCESS:
            return {
                ...state,
                loading: false,
                recordMomentaryCustomTime: payload
            }
        case BehaviourDataActionTypes.set_customMomentaryArray.SUCCESS:
            return {
                ...state,
                customMomentaryArray: payload
            }
        case BehaviourDataActionTypes.reset_customMomentaryArray.SUCCESS:
            return {
                ...state,
                customMomentaryArray: []
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/reducers/recordMomentaryReducer.js